var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
    fill: "#0073AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02807 13.4238C5.76869 13.4238 5.51557 13.3207 5.33119 13.1363L1.39057 9.19254C0.468691 8.22692 1.95932 6.93942 2.78432 7.79879L5.98432 11.0019L13.1718 2.91129C14.0218 1.95817 15.4937 3.27067 14.6437 4.22067L6.76244 13.0925C6.58119 13.2957 6.32494 13.4144 6.05619 13.4238C6.04682 13.4238 6.03744 13.4238 6.02807 13.4238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.ff9d24b0f396484d3b1ee8b60b90d38a.svg";
export { ForwardRef as ReactComponent };